//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class SupportTicketInformationModel extends ModelBase {
      static readonly $typeName = 'SupportTicketInformationModel';
      public key: string;
      public draftMessageToUsersDescription: string;
      public activeMessageToUsersDescription: string;
      public supportTicketEmailAddress: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/SupportTicketInformationModel.ts